import React from 'react'
import NavLinkMenu from '../../../../components/navlink/NavLinkMenu'
import AppTabMenu from '../../../../component/layout/AppTabMenu.tsx'

const CenterNavLinks = ({ id, centerType }) => {
  const options = [
    { id: 'data', path: `/app/centers/${id}/data` },
    {
      id: 'comercialData',
      path: `/app/centers/${id}/comercial-data`,
      disabled: !id || id === '' || id === 'undefined',
    },
    {
      id: 'workers',
      path: `/app/centers/${id}/workers`,
      disabled: !id || id === '' || id === 'undefined',
    },
    {
      id: 'contracts',
      path: `/app/centers/${id}/contracts`,
      disabled: !id || id === '' || id === 'undefined',
    },
    {
      id: 'technics',
      path: `/app/centers/${id}/technics`,
      disabled: !id || id === '' || id === 'undefined',
    },
    {
      id: 'maintenances',
      path: `/app/centers/${id}/maintenances`,
      disabled: !id || id === '' || id === 'undefined',
    },
    {
      id: 'cashRegisters',
      path: `/app/centers/${id}/cash-registers`,
      disabled: !id || id === '' || id === 'undefined',
    },
    // {id: 'conventions', path: `/app/centers/${id}/conventions`, disabled: !id || id === '' || id === 'undefined'},
    {
      id: 'services',
      path:
        !id ||
        id === '' ||
        id === 'undefined' ||
        !centerType ||
        centerType === 'FRANCHISE' ||
        centerType === 'OTHER'
          ? ''
          : `/app/centers/${id}/services`,
      disabled:
        !id ||
        id === '' ||
        id === 'undefined' ||
        !centerType ||
        centerType === 'FRANCHISE' ||
        centerType === 'OTHER',
    },
    {
      id: 'manuals',
      path:
        !id ||
        id === '' ||
        id === 'undefined' ||
        !centerType ||
        centerType === 'FRANCHISE' ||
        centerType === 'OTHER'
          ? ''
          : `/app/centers/${id}/manuals`,
      disabled:
        !id ||
        id === '' ||
        id === 'undefined' ||
        !centerType ||
        centerType === 'FRANCHISE' ||
        centerType === 'OTHER',
    },
  ]
  // if (centerType === 'OWNER' || centerType === 'FRANCHISE') {
  //     options.push({id: 'services', path: `/app/centers/${id}/services`, disabled: !id || id === '' || id === 'undefined'})
  // }
  // if (centerType === 'OWNER') {
  //     options.push({id: 'manuals', path: `/app/centers/${id}/manuals`})
  // }
  return (
    <AppTabMenu options={options} />
    // <NavLinkMenu version={1} level={1} navLinks={options} />
  )
}

export default CenterNavLinks
